import Picker from './Picker';
import Date from './DatePicker';

Picker.Date = Date;

export default Picker;



// WEBPACK FOOTER //
// ./components/Picker/index.js